import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';
import FilterBar from './filterBar';
import TriggerEngagement from './triggerEngagement';
import TriggerTable from './table';
import { setHeaderTitle } from '../../../redux/reducers/headerReducer';
import {
    getTriggersDetails,
    getTriggersSummaryGraphs,
    getTriggersSummaryPaginate,
} from '../../../redux/thunks/triggerThunk';
import { calculateMaxWidth, updateStringNPPA } from '../../../utility';
import { CustomAccordion } from '../../shared';
import Notes from '../../shared/notes';
import {
    excludes_triggerTableDefinitions_keys,
    prodQaCompnies,
    triggerTableDefinitions,
} from '../../../constants';
import { actions as triggerActions } from '../../../redux/reducers/triggerReducer';
import DistrictBreakdown from './districtBreakdown';
import DtcTriggerTable from './dtcTable';
import DtcTriggerEngagement from './dtcTriggerEngagement';
import DtcTopCityChart from './dtcTopCharts/dtcTopCityChart ';
import DtcTopChannelChart from './dtcTopCharts/dtcTopChannelChart';
import { getCompanyConfigurationByTag } from '../../../redux/thunks/companyThunks';

const Triggers = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const [maxWidth, setMaxWidth] = useState(calculateMaxWidth());
    const { trigger } = useParams();
    const { triggerSummary } = useSelector((state) => state.trigger);
    const { currentPage } = triggerSummary;
    const { startDateRange, endDateRange } = useSelector(
        (state) => state.filter,
    );
    const { company, isOmaniChannel } = useSelector((state) => state.company);
    const { companyConfig } = useSelector((state) => state.adminSettings);
    const { value } = companyConfig;
    const { resetToInitialState } = triggerActions;
    const hide_definations_companies = [97].includes(company.id);

    const getDefinitions = () => {
        const excludeFmtCompanies = [51, 53, 59, 140, 72, 90, 92, 72, 90, 92];
        if (excludeFmtCompanies.includes(company.id)) {
            return triggerTableDefinitions.filter(
                (defi) =>
                    !excludes_triggerTableDefinitions_keys.includes(defi.key),
            );
        }
        return triggerTableDefinitions;
    };

    useEffect(() => {
        const updatedTriggerName = updateStringNPPA(trigger);
        dispatch(setHeaderTitle(updatedTriggerName));
    }, []);

    useEffect(() => {
        if (company.id) {
            dispatch(getCompanyConfigurationByTag({ companyId: company.id }));
        }
    }, [company.id]);

    const isConfigReady =
        companyConfig && Object.keys(companyConfig).length > 0;

    useEffect(() => {
        if (company.id || isConfigReady) {
            dispatch(resetToInitialState());
            // this api is for
            dispatch(
                getTriggersSummaryGraphs({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    //isUnified: value?.toLowerCase() === 'true' || false ,
                    triggerNames: { triggers: [trigger.toLocaleLowerCase()] },
                }),
            );
        }
    }, [company, startDateRange, endDateRange, trigger, isConfigReady]);
    useEffect(() => {
        if (
            company.id &&
            trigger &&
            !isOmaniChannel &&
            (isConfigReady || true)
        ) {
            dispatch(
                getTriggersSummaryPaginate({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    batchNo: currentPage,
                    batchSize: 25,
                    //isUnified: value?.toLowerCase() === 'true' || false ,
                    triggerNames: { triggers: [trigger.toLowerCase()] },
                    type: 'table',
                }),
            );
        }
    }, [
        company,
        startDateRange,
        endDateRange,
        currentPage,
        isConfigReady,
        isOmaniChannel,
    ]);

    useEffect(() => {
        const handleResize = () => {
            setMaxWidth(calculateMaxWidth());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {/* Trigger Engagement */}
                <Grid item xs={12}>
                    {isOmaniChannel ? (
                        <DtcTriggerEngagement />
                    ) : (
                        <TriggerEngagement />
                    )}
                </Grid>
                {prodQaCompnies.includes(company.id) ? (
                    <Grid item xs={12}>
                        <DistrictBreakdown />
                    </Grid>
                ) : null}
                <Grid item xs={12}>
                    {isOmaniChannel || hide_definations_companies ? null : (
                        <Box sx={{ maxWidth: maxWidth }}>
                            <CustomAccordion
                                acoordianDetailsBackground="bg-white"
                                acoordianDetailsPadding="padding-t-8-b-16"
                                component={
                                    <Notes Definition={getDefinitions()} />
                                }
                                title="Definitions"
                            />
                        </Box>
                    )}
                </Grid>

                <Grid item xs={6}>
                    {isOmaniChannel ? <DtcTopCityChart /> : null}
                </Grid>
                <Grid item xs={6}>
                    {isOmaniChannel ? <DtcTopChannelChart /> : null}
                </Grid>

                <Grid item xs={12} sx={{ minWidth: 0 }}>
                    {isOmaniChannel ? <DtcTriggerTable /> : <TriggerTable />}
                </Grid>
            </Grid>
        </>
    );
};

export default Triggers;
